module.exports = fox._r("images/mc-intro-urban.jpg", __webpack_public_path__ + "images/mc-intro-urban.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/mc-intro-urban.jpg
// module id = 67
// module chunks = 2